import React from 'react';

import { TableHeadContainer, TableHeadItem } from '../../../components/TableHead';
import { dividendsHistoryTableHead } from '../constants';

export namespace ListHeaderTypes {
  export type Props = {
    isMobile?: boolean;
    isTablet?: boolean;
  };
}

export const ListHeader: React.FC<ListHeaderTypes.Props> = ({ isMobile, isTablet }) => {
  if (isMobile || isTablet) {
    return null;
  }

  const items = dividendsHistoryTableHead.map((item, index) => (
    <TableHeadItem
      key={item.title}
      testID={`table-head-title-${index}`}
      flex={item.flex}
      title={item.title}
    />
  ));

  return (
    <TableHeadContainer px="inline.xxxs" display={{ base: 'none', sm: 'flex' }}>
      {items}
    </TableHeadContainer>
  );
};
